import { Menu } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { Fragment } from 'react';
import { Button } from 'src/design-system/Button';

type SectionAddMenuItem = { value: string; label: string };
type SectionAddMenuGroup = { label: string; items: SectionAddMenuItem[] };
export type SectionAddMenuEntry = SectionAddMenuItem | SectionAddMenuGroup;

// A section's Add control is either a direct action or a product picker menu.
export type SectionAddAction =
  | { onAdd: () => void }
  | { entries: SectionAddMenuEntry[]; onSelect: (value: string) => void };

type SectionAddButtonProps = {
  action: SectionAddAction;
  ariaLabel?: string;
  testId?: string;
};

export function SectionAddButton({ action, ariaLabel, testId }: SectionAddButtonProps) {
  if (!('entries' in action)) {
    return (
      <Button
        variant="tertiary"
        size="xs"
        onClick={action.onAdd}
        aria-label={ariaLabel}
        data-testid={testId}
      >
        Add
      </Button>
    );
  }

  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <Button variant="tertiary" size="xs" px={9} aria-label={ariaLabel} data-testid={testId}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            Add
            <IconChevronDown
              size={16}
              color="var(--mantine-color-brand-7)"
              style={{ marginRight: 1 }}
            />
          </span>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {action.entries.map(entry =>
          'items' in entry ? (
            <Fragment key={entry.label}>
              <Menu.Label>{entry.label}</Menu.Label>
              {entry.items.map(item => (
                <Menu.Item key={item.value} onClick={() => action.onSelect(item.value)}>
                  {item.label}
                </Menu.Item>
              ))}
            </Fragment>
          ) : (
            <Menu.Item key={entry.value} onClick={() => action.onSelect(entry.value)}>
              {entry.label}
            </Menu.Item>
          ),
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
